export const addresses = {
  nounsProvider:"0x14fB3B15bc6046aa94A704EC86Bf795D16d05424",
  fontLondrinaSolid:"0x8493F51fA07a9bB978a8AD45f7185A26C1185b9E",
  pnouns:"0xbB57B4A979929EE85a82C2867F95795A6A3020a0",
}
